import React from 'react';
import { withRouter } from 'react-router';
import ScreenURLMap from './screenURLMap';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import screenURLMap from './screenURLMap';
import type { RootStackParamList } from '../../../../Types/rootStackParamsList';

const withRouterWrappedComponent = ({ WrappedComponent, wrappedComponentProps, history }) => {
  const updateParamsInURL = (url, params, queryParams) => {
    let queryString = '';
    if (params) {
      Object.keys(params).forEach(param => {
        url = url.replace(param, params[param]);
      });
    }
    if (!isEmpty(queryParams)) {
      const keys = Object.keys(queryParams);
      queryString = queryString.concat('?', keys[0], '=', encodeURIComponent(JSON.stringify(queryParams[keys[0]])));
      keys.slice(1).forEach(queryParam => {
        queryString = queryString.concat(
          '&',
          queryParam,
          '=',
          encodeURIComponent(JSON.stringify(queryParams[queryParam]))
        );
      });
      url = url.concat(queryString);
    }
    return url;
  };

  const customHistoryPush = <RouteName extends keyof typeof screenURLMap>({
    screen,
    state,
    params,
    webURL = '',
    queryParams = {},
    isOutsideLink = false
  }: {
    screen: RouteName;
    state: RootStackParamList[(typeof screenURLMap)[RouteName]['screenName']];
    params: object;
    webURL: string /** @deprecated use screen field instead */;
    queryParams: object;
    isOutsideLink: boolean;
  }) => {
    const url = webURL || get(ScreenURLMap[screen], 'url', '');
    const updatedURL = updateParamsInURL(url, params, queryParams);
    if (isOutsideLink) {
      window.open(updatedURL, '_self');
    } else {
      history.push(updatedURL, state);
    }
  };

  const goBack = () => {
    history.goBack();
  };

  const customHistoryReplace = <RouteName extends keyof typeof screenURLMap>({
    screen,
    state,
    params,
    webURL = '',
    queryParams
  }: {
    screen: RouteName;
    state: RootStackParamList[(typeof screenURLMap)[RouteName]['screenName']];
    params: object;
    webURL: string /** @deprecated use screen field instead */;
    queryParams: object;
  }) => {
    const url = webURL || get(ScreenURLMap[screen], 'url', '');
    const updatedURL = updateParamsInURL(url, params, queryParams);
    history.replace({ pathname: updatedURL, state });
  };

  const historyState = history.location.state;

  const screenUrlCta = history.location.pathname;
  const search = history.location.search;

  const customHistorySearchPush = ({ search }) => {
    history.push({ search: search });
  };

  const customHistory = {
    push: customHistoryPush,
    state: historyState,
    replace: customHistoryReplace,
    goBack: goBack,
    screenUrlCta,
    search,
    searchPush: customHistorySearchPush
  };

  return <WrappedComponent {...wrappedComponentProps} customHistory={customHistory} history={history} />;
};

export default withRouter(withRouterWrappedComponent);
